<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">

							</h6>
							<div class="element-box-tp">

								<table-component
										v-if="status == 200"
										table-class="table table-padded"
										filter-input-class="form-control col-4 float-right rounded bright"
										:data="roles"
										sort-by="id"
										sort-order="asc"
								>
									<template>
										<table-column show="id" label="#" cell-class="w50"></table-column>
										<table-column show="name" :label="t.name"></table-column>

										<table-column label="" :sortable="false" :filterable="false" cell-class="row-actions w50">
											<template scope="row">
												<router-link :to="{ name: 'roles_list', query: $route.query, params: {id: row.id} }">
													<i class="dashicons dashicons-edit"></i>
												</router-link>
											</template>
										</table-column>
									</template>
								</table-component>

								<paginate v-if="pagination.pageCount"
								          :page-count="pagination.pageCount"
								          :page-range="pagination.pageRange"
								          :force-page="(pagination.current-1)"
								          :margin-pages="2"
								          :click-handler="onChangePage"
								          :prev-text="t.previous"
								          :next-text="t.next"
								          :container-class="'pagination float-right'"
								          :page-class="'page-item'"
								          :page-link-class="'page-link'"
								          :prev-class="'page-item'"
								          :prev-link-class="'page-link'"
								          :next-class="'page-item'"
								          :next-link-class="'page-link'"
								>
								</paginate>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
			START - Sidebar
			-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
							<span class="when-closed">
									<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>

		<sweet-modal ref="umodal" v-on:close="closeModal">

			<sweet-modal-tab :title="t.user.info" id="tab1">

				<editForm v-if="$route.params.id" />

			</sweet-modal-tab>

		</sweet-modal>
	</div>
</template>

<script>


    import editForm from '@/components/user/roles/editForm'
    import { TableComponent, TableColumn } from 'vue-table-component'

    export default {
        name: 'rolesList',
	    components: {TableComponent, TableColumn, editForm},
        data () {
            return {
                w: window.innerWidth,
                status: 0,
                t: this.$root.t,
                isLoading: false,
                roles: []
            }
        },
	    watch: {
          '$route.params.id' (o, n) {

              this.$refs.umodal.open();

          }
	    },
	    mounted () {
          this.fetchRoles()

		    if (this.$route.params.id) {
             setTimeout( this.openModal(), 1000);

		    }
	    },
	    methods: {
            onChangePage (page) {
                this.pagination.current = page;

                this.$route.query.page = page;
                var qr = this.$route.query;
                this.$router.push({});

                this.$router.push({ query: qr });


                window.scroll(0, 0);
            },
            openModal () {
                this.$refs.umodal.open();
            },
            closeModal () {
                setTimeout(() => { document.body.style.overflow='auto'; }, 500 );
                var data = Object.assign({}, this.$route.params);
                data['id'] = null;
                this.$router.push({name: 'roles_list', params : data });
            },
            fetchRoles () {
                this.$http.get(api+'api/v1/users/groups')
                    .then(response => {

                    this.roles = response.body.result.groups;
                    this.pagination = response.body.pagination;
                    this.status = response.status;
                }, response => {

                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/roles/list.vue